module.exports = __webpack_public_path__ + "img/car_09.920174c9.jpg";